import clsx from 'clsx';
import React from 'react';
import {
  ApiFilterOperation,
  FilterComponentProps,
  Select,
  TableFilterState,
  TextField,
  useEventCallback,
} from '@eas/common-web';
import { Operation, useStringOperations } from '../filter-api';
import { useStyles } from '../filter-styles';

export function buildTextFilterState(
  state: TableFilterState,
  operation: ApiFilterOperation,
  value: string | null,
  field: string
): TableFilterState {
  if (operation === ApiFilterOperation.NOT) {
    return {
      ...state,
      operation: ApiFilterOperation.NOT,
      value,
      filters: value
        ? [
            {
              field,
              operation: ApiFilterOperation.CONTAINS,
              value,
              object: null,
            },
          ]
        : undefined,
    };
  }

  const rest = { ...state };
  delete rest.filters;

  return {
    ...rest,
    operation,
    value,
  };
}

export function DisabledFilterTextCell(props: FilterComponentProps) {
  return <FilterTextCell {...props} disabled={true} />;
}

export function FilterTextCell({
  disabled,
  value,
  state,
  onChangeState,
  filter,
  handleValueChange,
  handleOperationChange,
  operation,
}: FilterComponentProps & {
  handleValueChange?: any;
  handleOperationChange?: any;
  operation?: ApiFilterOperation;
}) {
  const classes = useStyles();
  const operations = useStringOperations();
  const textOperation = operation ?? state.operation;
  const field = filter.filterkey ?? filter.datakey;
  const defaultHandleValueChange = useEventCallback(
    (newValue: string | null) => {
      onChangeState(
        buildTextFilterState(state, textOperation, newValue, field)
      );
    }
  );
  const defaultHandleOperationChange = useEventCallback(
    (newOperation: Operation | Operation[] | string | string[] | null) => {
      if (!newOperation) {
        return;
      }

      onChangeState(
        buildTextFilterState(
          state,
          newOperation as ApiFilterOperation,
          value,
          field
        )
      );
    }
  );

  return (
    <div className={clsx(classes.root, { [classes.disabled]: disabled })}>
      <div
        className={clsx(classes.selectWrapper, classes.compactSelectWrapper)}
      >
        <Select
          source={operations}
          value={textOperation}
          onChange={handleOperationChange ?? defaultHandleOperationChange}
          valueIsId={true}
          clearable={false}
          disabled={disabled}
        />
      </div>
      <div className={classes.compactTextWrapper}>
        <TextField
          value={value}
          onChange={handleValueChange ?? defaultHandleValueChange}
          disabled={disabled}
        />
      </div>
    </div>
  );
}
